import { render, staticRenderFns } from "./MobileTest.vue?vue&type=template&id=ab0aa71c&scoped=true&"
import script from "./MobileTest.vue?vue&type=script&lang=js&"
export * from "./MobileTest.vue?vue&type=script&lang=js&"
import style0 from "./MobileTest.vue?vue&type=style&index=0&id=ab0aa71c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0aa71c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VCard,VCardSubtitle,VContainer,VIcon,VSheet,VSpacer,VSystemBar})
